import React, { useState, useEffect, useCallback, useMemo } from "react";
import "./register.css";
import TicketCard from "../Registerutils/TicketCard";
import { EventRegister } from "../../../../api/Webservices";
import {
  FaPlus as Plus,
  FaTrash as Trash2,
  FaChevronRight as ChevronRight,
  FaCalendarAlt as Calendar,
  FaMapMarkerAlt as MapPin,
  FaUsers as Users,
  FaUserPlus as UserPlus,
  FaChevronDown as ChevronDown,
  FaChevronUp as ChevronUp,
  FaMinus as Minus,
  FaTimes as X,
} from "react-icons/fa";
import { useParams } from "react-router-dom";
import { ComingSoon } from "../utils/ComingSoon";
import { SkeletonLoader } from "../utils/SkeletonLoader";
import { CompletedEvent } from "../utils/CompletedEvent";
import { useRegistration } from "../../../../context/RegistrationContext";
const TraditionalLoader = () => (
  <div className="traditional-loader-container">
    <div className="traditional-loader"></div>
    <style>
      {`
        .traditional-loader-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 50vh;
        }
        .traditional-loader {
          width: 40px;
          height: 40px;
          border: 4px solid #e5e7eb;
          border-top: 4px solid #3b82f6;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
);
const getCategoryClass = (category) => {
  const classes = {
    Student: "badge-student",
    Workshop: "badge-workshop",
    Professional: "badge-professional",
    General: "badge-general",
  };
  return classes[category] || "badge-general";
};
export default function AmasiconRegistration({
  eventData,
  onProceed,
  completeEventData,
}) {
  const { eventSlug, token } = useParams();
  const [expandedGuestCard, setExpandedGuestCard] = useState(null);
  const [showViewDetails, setShowViewDetails] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [ticketValues, setTicketValues] = useState([]);
  const [tooltip, setTooltip] = useState("");
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccessLoader, setShowSuccessLoader] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const { updateRegistrationData } = useRegistration();
  const stateIsSame = completeEventData?.state_is_same === "yes";
  useEffect(() => {
    console.log("Received eventData:", eventData);
    if (eventData && eventData.tickets) {
      if (eventData.tickets.length === 0) {
        setLoading(false);
        return;
      }
      const parsedTickets = eventData.tickets.map((ticket) => {
        const price = Number.parseFloat(ticket.price) || 0;
        const isFree = price === 0;
        return {
          id: ticket.id.toString(),
          title: ticket.ticket_name,
          price,
          currency: ticket.currency,
          description: ticket.description || "",
          category: isFree
            ? "Free"
            : ticket.ticket_type === "paid"
            ? ""
            : "Free",
          tax_type: ticket.tax_type,
          tax_options: ticket.tax_options
            ? typeof ticket.tax_options === "string"
              ? JSON.parse(ticket.tax_options)
              : ticket.tax_options
            : [],
          isAdded: false,
          ticketQuantity: 0,
          guestCount: 0,
          guestPrice: ticket.guest_details
            ? Number.parseFloat(JSON.parse(ticket.guest_details).price || 100)
            : 100,
          hasAddOns: ticket.addons && JSON.parse(ticket.addons).length > 0,
          maxTickets: ticket.ticket_max_order || ticket.balance_count,
          balance: ticket.balance_count,
          addons: ticket.addons
            ? JSON.parse(ticket.addons).map((addon) => {
                const linkedTicket = addon.linked_tickets?.find(
                  (lt) => lt.ticket_id === ticket.id
                );
                const maxQuantity = linkedTicket
                  ? linkedTicket.max_quantity
                  : addon.quantity;
                return {
                  ...addon,
                  tax_options: addon.tax_options
                    ? typeof addon.tax_options === "string"
                      ? JSON.parse(addon.tax_options)
                      : addon.tax_options
                    : [],
                  selectedVariant: null,
                  isAdded: false,
                  quantity: 0,
                  maxQuantity: maxQuantity || 1,
                };
              })
            : [],
          guest_details: ticket.guest_details
            ? JSON.parse(ticket.guest_details)
            : null,
          form_details: ticket.form_details
            ? JSON.parse(ticket.form_details)
            : {},
          attendeeIDs: [],
          guestIDs: [],
          private_ticket: ticket.private_ticket,
          ticket_status: ticket.ticket_status,
        };
      });
      console.log("Parsed tickets:", parsedTickets);
      setTickets(parsedTickets);
      setTicketValues(parsedTickets);
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [eventData]);
  const allowBuyers = completeEventData?.settings?.allow_buyers === 1;
const allowMultipleTickets = completeEventData?.settings?.allow_attendee_buy_multiple_ticket === 1;
const updateTicketQuantity = useCallback(
  (id, change) => {
    if (!allowMultipleTickets && change > 0) {
      const alreadySelected = tickets.some(
        (t) => t.isAdded && t.id !== id && t.ticketQuantity > 0
      );
      if (alreadySelected) {
        setTooltip("Only one ticket type is allowed.");
        setTimeout(() => setTooltip(""), 2000);
        return;
      }
    }
    setTickets((prevTickets) => {
      const targetTicket = prevTickets.find((t) => t.id === id);
      const maxTickets = Math.min(targetTicket.maxTickets, targetTicket.balance);
      return prevTickets.map((ticket) => {
        if (ticket.id === id) {
          let newQuantity = ticket.ticketQuantity + change;
          if (!allowMultipleTickets) {
            newQuantity = change > 0 ? 1 : 0;
          } else {
            newQuantity = Math.max(0, Math.min(maxTickets, newQuantity));
          }
          if (newQuantity >= maxTickets && change > 0) {
            setTooltip("Maximum available quantity reached");
            setTimeout(() => setTooltip(""), 2000);
          }
          if (newQuantity > 0 && !selectedCurrency) {
            setSelectedCurrency(ticket.currency);
          } else if (newQuantity === 0 && ticket.ticketQuantity > 0) {
            const otherSelected = prevTickets.filter(
              (t) => t.id !== id && t.isAdded && t.ticketQuantity > 0
            );
            if (otherSelected.length === 0) {
              setSelectedCurrency(null);
            }
          }
          return {
            ...ticket,
            ticketQuantity: newQuantity,
            isAdded: newQuantity > 0,
            guestCount: allowBuyers
              ? ticket.guestCount
              : Math.min(ticket.guestCount, 1),
            attendeeIDs:
              newQuantity > 0 ? ticket.attendeeIDs.slice(0, newQuantity) : [],
          };
        }
        return ticket;
      });
    });
    setErrorMessage("");
  },
  [selectedCurrency, allowBuyers, allowMultipleTickets, tickets]
);
  const updateGuestCount = useCallback(
    (id, change) => {
      setTickets((prevTickets) => {
        return prevTickets.map((ticket) => {
          if (ticket.id === id) {
            const maxGuests = allowBuyers
              ? ticket.guest_details?.ticket_max_order || ticket.balance
              : 1;
            const newCount = Math.max(
              0,
              Math.min(maxGuests, ticket.guestCount + change)
            );
            if (newCount >= maxGuests && change > 0) {
              setTooltip("Maximum available guest quantity reached");
              setTimeout(() => setTooltip(""), 2000);
            }
            return {
              ...ticket,
              guestCount: newCount,
              guestIDs: newCount > 0 ? ticket.guestIDs.slice(0, newCount) : [],
            };
          }
          return ticket;
        });
      });
      setErrorMessage("");
    },
    [allowBuyers]
  );
  const toggleGuestExpansion = useCallback((id) => {
    setExpandedGuestCard((prev) => (prev === id ? null : id));
  }, []);
  const toggleAddon = useCallback((ticketId, addonId, variant = null) => {
    setTickets((prevTickets) =>
      prevTickets.map((ticket) => {
        if (ticket.id === ticketId && ticket.isAdded) {
          const updatedAddons = ticket.addons.map((addon) => {
            if (addon.id === addonId) {
              if (addon.addons_type === "variant" && variant) {
                return {
                  ...addon,
                  isAdded: !addon.isAdded,
                  selectedVariant: addon.isAdded ? null : variant,
                  quantity: addon.isAdded ? 0 : 1,
                };
              } else if (addon.addons_type === "single") {
                return {
                  ...addon,
                  isAdded: !addon.isAdded,
                  quantity: addon.isAdded
                    ? 0
                    : Math.min(1, addon.maxQuantity || 1),
                };
              }
            }
            return addon;
          });
          return { ...ticket, addons: updatedAddons };
        }
        return ticket;
      })
    );
    setErrorMessage("");
  }, []);
  const updateAddonQuantity = useCallback((ticketId, addonId, change) => {
    setTickets((prevTickets) =>
      prevTickets.map((ticket) => {
        if (ticket.id === ticketId) {
          const updatedAddons = ticket.addons.map((addon) => {
            if (addon.id === addonId && addon.isAdded) {
              const maxQuantity = addon.maxQuantity || 1;
              const newQuantity = Math.max(
                0,
                Math.min(maxQuantity, addon.quantity + change)
              );
              if (newQuantity >= maxQuantity && change > 0) {
                setTooltip("Maximum available add-on quantity reached");
                setTimeout(() => setTooltip(""), 2000);
              }
              return { ...addon, quantity: newQuantity };
            }
            return addon;
          });
          return { ...ticket, addons: updatedAddons };
        }
        return ticket;
      })
    );
    setErrorMessage("");
  }, []);
  const addedTickets = useMemo(
    () => tickets.filter((ticket) => ticket.isAdded),
    [tickets]
  );
  const totalGuests = useMemo(
    () => addedTickets.reduce((sum, ticket) => sum + ticket.guestCount, 0),
    [addedTickets]
  );
  const { subtotal, tax, total, taxName } = useMemo(() => {
    let subtotal = 0;
    let tax_total = 0;
    console.log("Starting tax calculation for addedTickets:", addedTickets);
    addedTickets.forEach((ticket, index) => {
      console.log(
        `Processing ticket ${index + 1} of ${addedTickets.length}:`,
        ticket
      );
      const base = Number(ticket.price) || 0;
      const qty = ticket.ticketQuantity;
      const tax_options =
        typeof ticket.tax_options === "string"
          ? JSON.parse(ticket.tax_options)
          : ticket.tax_options || [];
      console.log(
        `Ticket ${
          index + 1
        } - Base Price: ${base}, Quantity: ${qty}, Tax Options:`,
        tax_options
      );
      const stateIsSame = completeEventData?.state_is_same === "yes";
      console.log(
        `Ticket ${
          index + 1
        } - state_is_same: ${stateIsSame}, completeEventData:`,
        completeEventData
      );
      const relevantTaxes = stateIsSame
        ? tax_options.filter((t) => ["CGST", "SGST"].includes(t.tax_name))
        : tax_options.filter((t) => t.tax_name === "IGST");
      console.log(
        `Ticket ${index + 1} - Relevant Taxes after filtering:`,
        relevantTaxes
      );
      const rate =
        relevantTaxes.reduce((sum, t) => {
          const percentage = Number.parseFloat(t.tax_percentage) || 0;
          console.log(
            `Ticket ${index + 1} - Adding tax: ${t.tax_name} = ${percentage}%`
          );
          return sum + percentage;
        }, 0) / 100;
      console.log(`Ticket ${index + 1} - Calculated Tax Rate: ${rate * 100}%`);
      let item_net = 0;
      let item_tax = 0;
      if (ticket.category === "Free" || ticket.tax_type === "No Tax") {
        item_net = base * qty;
        item_tax = 0;
      } else if (ticket.tax_type === "Including Tax") {
        const item_total = base * qty;
        const denom = 1 + rate;
        item_net = denom > 1 ? item_total / denom : item_total;
        item_tax = item_total - item_net;
      } else if (ticket.tax_type === "Excluding Tax") {
        item_net = base * qty;
        item_tax = item_net * rate;
      }
      console.log(
        `Ticket ${
          index + 1
        } - Item Net: ${item_net}, Item Tax: ${item_tax}, Total: ${
          item_net + item_tax
        }`
      );
      subtotal += item_net;
      tax_total += item_tax;
      if (ticket.guestCount > 0 && ticket.guest_details) {
        const g_base = Number(ticket.guestPrice) || 0;
        const g_qty = ticket.guestCount;
        const g_tax_options =
          typeof ticket.guest_details.tax_options === "string"
            ? JSON.parse(ticket.guest_details.tax_options)
            : ticket.guest_details.tax_options || [];
        console.log(
          `Ticket ${
            index + 1
          } - Guest Base Price: ${g_base}, Quantity: ${g_qty}, Guest Tax Options:`,
          g_tax_options
        );
        const g_relevantTaxes = stateIsSame
          ? g_tax_options.filter((t) => ["CGST", "SGST"].includes(t.tax_name))
          : g_tax_options.filter((t) => t.tax_name === "IGST");
        console.log(
          `Ticket ${index + 1} - Guest Relevant Taxes:`,
          g_relevantTaxes
        );
        const g_rate =
          g_relevantTaxes.reduce((sum, t) => {
            const percentage = Number.parseFloat(t.tax_percentage) || 0;
            console.log(
              `Ticket ${index + 1} - Guest Adding tax: ${
                t.tax_name
              } = ${percentage}%`
            );
            return sum + percentage;
          }, 0) / 100;
        console.log(`Ticket ${index + 1} - Guest Tax Rate: ${g_rate * 100}%`);
        const g_tax_type = ticket.guest_details.tax_type || "No Tax";
        let g_net = 0;
        let g_tax = 0;
        if (g_tax_type === "No Tax") {
          g_net = g_base * g_qty;
          g_tax = 0;
        } else if (g_tax_type === "Including Tax") {
          const g_total = g_base * g_qty;
          const denom = 1 + g_rate;
          g_net = denom > 1 ? g_total / denom : g_total;
          g_tax = g_total - g_net;
        } else if (g_tax_type === "Excluding Tax") {
          g_net = g_base * g_qty;
          g_tax = g_net * g_rate;
        }
        console.log(
          `Ticket ${
            index + 1
          } - Guest Net: ${g_net}, Guest Tax: ${g_tax}, Guest Total: ${
            g_net + g_tax
          }`
        );
        subtotal += g_net;
        tax_total += g_tax;
      }
      ticket.addons.forEach((addon, addonIndex) => {
        if (addon.isAdded && addon.addon_status === "onsale") {
          const a_base =
            addon.addons_type === "variant" && addon.selectedVariant
              ? Number.parseFloat(addon.selectedVariant.price) || 0
              : Number.parseFloat(addon.price || 0);
          const a_qty = addon.quantity;
          const a_tax_options = addon.tax_options || [];
          console.log(
            `Ticket ${index + 1} - Addon ${
              addonIndex + 1
            } - Base Price: ${a_base}, Quantity: ${a_qty}, Tax Options:`,
            a_tax_options
          );
          const a_relevantTaxes = stateIsSame
            ? a_tax_options.filter((t) => ["CGST", "SGST"].includes(t.tax_name))
            : a_tax_options.filter((t) => t.tax_name === "IGST");
          console.log(
            `Ticket ${index + 1} - Addon ${addonIndex + 1} - Relevant Taxes:`,
            a_relevantTaxes
          );
          const a_rate =
            a_relevantTaxes.reduce((sum, t) => {
              const percentage = Number.parseFloat(t.tax_percentage) || 0;
              console.log(
                `Ticket ${index + 1} - Addon ${addonIndex + 1} - Adding tax: ${
                  t.tax_name
                } = ${percentage}%`
              );
              return sum + percentage;
            }, 0) / 100;
          console.log(
            `Ticket ${index + 1} - Addon ${addonIndex + 1} - Tax Rate: ${
              a_rate * 100
            }%`
          );
          const a_tax_type = addon.tax_type || "No Tax";
          let a_net = 0;
          let a_tax = 0;
          if (a_tax_type === "No Tax") {
            a_net = a_base * a_qty;
            a_tax = 0;
          } else if (a_tax_type === "Including Tax") {
            const a_total = a_base * a_qty;
            const denom = 1 + a_rate;
            a_net = denom > 1 ? a_total / denom : a_total;
            a_tax = a_total - a_net;
          } else if (a_tax_type === "Excluding Tax") {
            a_net = a_base * a_qty;
            a_tax = a_net * a_rate;
          }
          console.log(
            `Ticket ${index + 1} - Addon ${
              addonIndex + 1
            } - Net: ${a_net}, Tax: ${a_tax}, Total: ${a_net + a_tax}`
          );
          subtotal += a_net;
          tax_total += a_tax;
        }
      });
    });
    console.log(`Final Subtotal: ${subtotal}, Final Tax: ${tax_total}`);
    const tax = Math.round(tax_total * 100) / 100;
    const total = Math.round((subtotal + tax_total) * 100) / 100;
    const taxName =
      completeEventData?.state_is_same === "yes" ? "SGST + CGST" : "IGST";
    console.log(
      `Final Tax: ${tax}, Final Total: ${total}, Tax Name: ${taxName}`
    );
    return { subtotal, tax, total, taxName };
  }, [addedTickets, eventData, completeEventData]);
  const areMandatoryAddonsSelected = useCallback(() => {
    return addedTickets.every((ticket) =>
      ticket.addons.every(
        (addon) =>
          addon.addon_status !== "paused" &&
          (!addon.isMandatory || (addon.isMandatory && addon.isAdded))
      )
    );
  }, [addedTickets]);
  const hasMainTicket = useMemo(
    () =>
      addedTickets.some(
        (ticket) => ticket.isAdded && ticket.category !== "Workshop"
      ),
    [addedTickets]
  );
  const formatDate = useCallback((dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  }, []);
  const handleProceed = useCallback(async () => {
    if (!allowBuyers && addedTickets.length > 1) {
      setErrorMessage("Only one ticket type is allowed for this event.");
      return;
    }
    if (!allowBuyers && totalGuests > 1) {
      setErrorMessage("Only one guest ticket is allowed for this event.");
      return;
    }
    if (addedTickets.length === 0) {
      setErrorMessage("Please select at least one ticket.");
      return;
    }
    const payload = {
      event_id: eventData?.event?.id || 1,
      tickets: addedTickets.map((ticket) => ({
        ticket_id: Number.parseInt(ticket.id),
        quantity: ticket.ticketQuantity,
        guest_count: ticket.guestCount,
        add_ons: ticket.addons
          .filter((addon) => addon.isAdded)
          .map((addon) => ({
            id: addon.id,
            quantity: addon.quantity,
            variant: addon.selectedVariant ? addon.selectedVariant.name : null,
          })),
      })),
      buyer_details:
        addedTickets.reduce(
          (sum, ticket) => sum + ticket.ticketQuantity + ticket.guestCount,
          0
        ) > 1
          ? { buyer_type: "individual", custom_fields: [] }
          : null,
      ticket_count: addedTickets.reduce(
        (sum, ticket) => sum + ticket.ticketQuantity + ticket.guestCount,
        0
      ),
      payment_date: new Date().toISOString().slice(0, 19).replace("T", " "),
      payment_method: "pending",
      payment_received: "0.00",
      additional_notes: "Pre-registration for attendee IDs",
      total_amount: total.toFixed(2),
      currency: addedTickets[0]?.currency || "INR",
      total_addons_amount: "0.00",
      total_tax_amount: tax.toFixed(2),
      total_ticket_amount: subtotal.toFixed(2),
    };
    try {
      setShowSuccessLoader(true);
      const response = await EventRegister(payload);
      if (response.success) {
        const attendeeIDs = response.attendee_ids || [];
        let idIndex = 0;
        const updatedTickets = tickets.map((ticket) => {
          if (!ticket.isAdded) return ticket;
          const ticketAttendeeIDs = [];
          for (let i = 0; i < ticket.ticketQuantity; i++) {
            if (idIndex < attendeeIDs.length) {
              ticketAttendeeIDs.push(attendeeIDs[idIndex++]);
            }
          }
          const guestIDs = [];
          for (let i = 0; i < ticket.guestCount; i++) {
            if (idIndex < attendeeIDs.length) {
              guestIDs.push(attendeeIDs[idIndex++]);
            }
          }
          return { ...ticket, attendeeIDs: ticketAttendeeIDs, guestIDs };
        });
        setTickets(updatedTickets);
        setErrorMessage("");
        const attendeesPaymentsId =
          response.attendees_payments_id || response.id || null;
        if (!attendeesPaymentsId) {
          console.warn(
            "attendees_payments_id not found in response, using null as fallback"
          );
        }
        updateRegistrationData({
          attendees_payments_id: attendeesPaymentsId,
          attendee_ids: attendeeIDs,
        });
        const attendeesIdsData = {
          attendees_payments_id: attendeesPaymentsId,
          attendee_ids: attendeeIDs,
        };
        localStorage.setItem("draft_ids", JSON.stringify(attendeesIdsData));
        setTimeout(() => {
          setShowSuccessLoader(false);
          onProceed(
            updatedTickets.filter((ticket) => ticket.isAdded),
            "attendees",
            attendeesPaymentsId
          );
        }, 1000);
      } else {
        setShowSuccessLoader(false);
        setErrorMessage("Failed to pre-register tickets. Please try again.");
      }
    } catch (err) {
      console.error("Error pre-registering tickets:", err);
      setShowSuccessLoader(false);
      setErrorMessage(
        "An error occurred during pre-registration. Please try again."
      );
    }
  }, [
    addedTickets,
    totalGuests,
    eventData,
    onProceed,
    updateRegistrationData,
    total,
    tax,
    subtotal,
  ]);
  const NoTicketsAvailable = () => (
    <>
      <div className="sticky-event-header">
        <div className="sticky-event-content">
          <h1 className="sticky-event-title">
            {eventData?.event?.event_name || "Event"}
          </h1>
          <div className="sticky-event-details">
            <div className="sticky-event-item">
              <Calendar className="icon-sm" />
              <span>
                {eventData?.event
                  ? `${formatDate(eventData.event.start_date)} - ${formatDate(
                      eventData.event.end_date
                    )}`
                  : "Loading..."}
              </span>
            </div>
            <div className="sticky-event-separator"></div>
            <div className="sticky-event-item">
              <MapPin className="icon-sm" />
              <span>{eventData?.event?.venue_city || "Location"}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="card-header">
        <div style={{ position: "relative", marginBottom: "60px" }}>
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "100px",
              overflow: "hidden",
              borderRadius: "12px 12px 0 0",
              background:
                eventData?.event_pages?.event_banner_image &&
                JSON.parse(eventData.event_pages.event_banner_image).show ===
                  "yes" &&
                JSON.parse(eventData.event_pages.event_banner_image).value
                  ? "none"
                  : eventData?.event_pages?.custom_theme &&
                    JSON.parse(eventData.event_pages.custom_theme).show ===
                      "yes"
                  ? JSON.parse(eventData.event_pages.custom_theme).type ===
                      "color" &&
                    JSON.parse(eventData.event_pages.custom_theme).color
                    ? JSON.parse(eventData.event_pages.custom_theme).color
                    : JSON.parse(eventData.event_pages.custom_theme).gradient ||
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                  : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            }}
          >
            {eventData?.event_pages?.event_banner_image &&
              JSON.parse(eventData.event_pages.event_banner_image).show ===
                "yes" &&
              JSON.parse(eventData.event_pages.event_banner_image).value && (
                <img
                  src={
                    JSON.parse(eventData.event_pages.event_banner_image).value
                  }
                  alt="Event Banner"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              )}
            {(!eventData?.event_pages?.event_banner_image ||
              JSON.parse(eventData.event_pages.event_banner_image).show !==
                "yes" ||
              !JSON.parse(eventData.event_pages.event_banner_image).value) &&
              eventData?.event_pages?.custom_theme &&
              JSON.parse(eventData.event_pages.custom_theme).show === "yes" &&
              JSON.parse(eventData.event_pages.custom_theme).type === "image" &&
              JSON.parse(eventData.event_pages.custom_theme).image_url && (
                <img
                  src={JSON.parse(eventData.event_pages.custom_theme).image_url}
                  alt="Event Banner"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              )}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.6))",
                zIndex: 1,
              }}
            ></div>
          </div>
          <div
            style={{
              position: "absolute",
              top: "50px",
              left: "50%",
              zIndex: 10,
              transform: "translateX(-50%)",
            }}
          >
            <div
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "16px",
                background: "#ffffff",
                padding: "8px",
                boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                border: "3px solid #ffffff",
              }}
            >
              <img
                src={
                  eventData?.event?.event_logo ||
                  "https://amasi.org/wp-content/themes/amasi/assets/images/logo.png"
                }
                alt="Event Logo"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "8px",
                  display: "block",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card-content">
        <div className="no-tickets-container" style={{ textAlign: 'center', padding: '2rem 1rem', maxWidth: '500px', margin: '0 auto' }}>
         
          <h3 className="content-title" style={{ color: '#ef4444', fontSize: '1.5rem', marginBottom: '0.5rem' }}>
            No Tickets Available
          </h3>
          <p className="error-message" style={{ color: '#6b7280', fontSize: '1rem', lineHeight: '1.5' }}>
            Sorry, no tickets are currently available for this event. 
          </p>
        </div>
      </div>
    </>
  );
  const RegistrationPage = () => (
    <>
      <div className="sticky-event-header">
        <div className="sticky-event-content">
          <h1 className="sticky-event-title">
            {eventData?.event?.event_name || "Event"}
          </h1>
          <div className="sticky-event-details">
            <div className="sticky-event-item">
              <Calendar className="icon-sm" />
              <span>
                {eventData?.event
                  ? `${formatDate(eventData.event.start_date)} - ${formatDate(
                      eventData.event.end_date
                    )}`
                  : "Loading..."}
              </span>
            </div>
            <div className="sticky-event-separator"></div>
            <div className="sticky-event-item">
              <MapPin className="icon-sm" />
              <span>{eventData?.event?.venue_city || "Location"}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="card-header">
        <div style={{ position: "relative", marginBottom: "60px" }}>
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "100px",
              overflow: "hidden",
              borderRadius: "12px 12px 0 0",
              background:
                eventData?.event_pages?.event_banner_image &&
                JSON.parse(eventData.event_pages.event_banner_image).show ===
                  "yes" &&
                JSON.parse(eventData.event_pages.event_banner_image).value
                  ? "none"
                  : eventData?.event_pages?.custom_theme &&
                    JSON.parse(eventData.event_pages.custom_theme).show ===
                      "yes"
                  ? JSON.parse(eventData.event_pages.custom_theme).type ===
                      "color" &&
                    JSON.parse(eventData.event_pages.custom_theme).color
                    ? JSON.parse(eventData.event_pages.custom_theme).color
                    : JSON.parse(eventData.event_pages.custom_theme).gradient ||
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                  : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            }}
          >
            {eventData?.event_pages?.event_banner_image &&
              JSON.parse(eventData.event_pages.event_banner_image).show ===
                "yes" &&
              JSON.parse(eventData.event_pages.event_banner_image).value && (
                <img
                  src={
                    JSON.parse(eventData.event_pages.event_banner_image).value
                  }
                  alt="Event Banner"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              )}
            {(!eventData?.event_pages?.event_banner_image ||
              JSON.parse(eventData.event_pages.event_banner_image).show !==
                "yes" ||
              !JSON.parse(eventData.event_pages.event_banner_image).value) &&
              eventData?.event_pages?.custom_theme &&
              JSON.parse(eventData.event_pages.custom_theme).show === "yes" &&
              JSON.parse(eventData.event_pages.custom_theme).type === "image" &&
              JSON.parse(eventData.event_pages.custom_theme).image_url && (
                <img
                  src={JSON.parse(eventData.event_pages.custom_theme).image_url}
                  alt="Event Banner"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              )}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.6))",
                zIndex: 1,
              }}
            ></div>
          </div>
          <div
            style={{
              position: "absolute",
              top: "50px",
              left: "50%",
              zIndex: 10,
              transform: "translateX(-50%)",
            }}
          >
            <div
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "16px",
                background: "#ffffff",
                padding: "8px",
                boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                border: "3px solid #ffffff",
              }}
            >
              <img
                src={
                  eventData?.event?.event_logo ||
                  "https://amasi.org/wp-content/themes/amasi/assets/images/logo.png"
                }
                alt="Event Logo"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "8px",
                  display: "block",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card-content">
        {errorMessage && (
          <div className="error-message text-red-500 text-sm mb-4">
            {errorMessage}
          </div>
        )}
        <div className="content-header">
          {eventData?.event?.registration_title && (
            <>
              <Users className="content-icon" />
              <h3 className="content-title">
                {eventData?.event?.registration_title}
              </h3>
            </>
          )}
        </div>
        <div className="tickets-container">
          {tickets.map((ticket) => (
            <TicketCard
              key={ticket.id}
              ticket={ticket}
              updateTicketQuantity={updateTicketQuantity}
              updateGuestCount={updateGuestCount}
              toggleGuestExpansion={toggleGuestExpansion}
              toggleAddon={toggleAddon}
              updateAddonQuantity={updateAddonQuantity}
              selectedCurrency={selectedCurrency}
              allowBuyers={allowBuyers}
              taxName={taxName}
              expandedGuestCard={expandedGuestCard}
              tooltip={tooltip}
              allowMultipleTickets={allowMultipleTickets}
              stateIsSame={stateIsSame}
              setTooltip={setTooltip}
              hasOtherTicketsSelected={addedTickets.some(
                (t) => t.id !== ticket.id && t.isAdded && t.ticketQuantity > 0
              )}
            />
          ))}
        </div>
      </div>
      <div className="sticky-bottom w-full">
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="total-section">
          <div className="total-info">
            <div className="total-price">
              {addedTickets?.[0]?.currency || "INR"}{" "}
              {total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
            <div className="total-details">
              {addedTickets.reduce(
                (sum, ticket) => sum + ticket.ticketQuantity,
                0
              ) +
                totalGuests +
                addedTickets.reduce(
                  (sum, ticket) =>
                    sum +
                    ticket.addons.reduce(
                      (addonSum, addon) =>
                        addonSum + (addon.isAdded ? addon.quantity : 0),
                      0
                    ),
                  0
                )}{" "}
              item
              {addedTickets.reduce(
                (sum, ticket) => sum + ticket.ticketQuantity,
                0
              ) +
                totalGuests +
                addedTickets.reduce(
                  (sum, ticket) =>
                    sum +
                    ticket.addons.reduce(
                      (addonSum, addon) =>
                        addonSum + (addon.isAdded ? addon.quantity : 0),
                      0
                    ),
                  0
                ) !==
              1
                ? "s"
                : ""}{" "}
              added{" "}
              <button
                onClick={() => setShowViewDetails(true)}
                className="view-details-link"
              >
                View Details
              </button>
            </div>
          </div>
          <button
            className="btn btn-primary"
            disabled={addedTickets.length === 0 || showSuccessLoader}
            onClick={handleProceed}
          >
            Proceed <ChevronRight className="icon-lg" />
          </button>
          {errorMessage && (
            <div className="error-message text-red-500 text-sm mt-2">
              {errorMessage}
            </div>
          )}
        </div>
      </div>
      {showViewDetails && (
        <div
          className="modal-overlay"
          onClick={() => setShowViewDetails(false)}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Selected Items</h3>
              <button
                onClick={() => setShowViewDetails(false)}
                className="modal-close"
              >
                <X className="icon-md" />
              </button>
            </div>
            <div className="modal-body">
              <div className="details-section">
                <h4 className="details-title">
                  Tickets -{" "}
                  {addedTickets.reduce(
                    (sum, ticket) => sum + ticket.ticketQuantity,
                    0
                  )}
                </h4>
                <div className="details-items">
                  {addedTickets.map((ticket) => {
                    const tax_options =
                      typeof ticket.tax_options === "string"
                        ? JSON.parse(ticket.tax_options)
                        : ticket.tax_options || [];
                    const relevantTaxes = stateIsSame
                      ? tax_options.filter((t) =>
                          ["CGST", "SGST"].includes(t.tax_name)
                        )
                      : tax_options.filter((t) => t.tax_name === "IGST");
                    const rate =
                      relevantTaxes.reduce(
                        (sum, t) =>
                          sum + (Number.parseFloat(t.tax_percentage) || 0),
                        0
                      ) / 100;
                    let itemTotal = ticket.price * ticket.ticketQuantity;
                    if (
                      ticket.category !== "Free" &&
                      ticket.tax_type === "Excluding Tax"
                    ) {
                      itemTotal += ticket.price * ticket.ticketQuantity * rate;
                    }
                    itemTotal = Math.round(itemTotal * 100) / 100;
                    return (
                      <div key={ticket.id} className="detail-item">
                        <div className="item-info">
                          <span className="item-quantity">
                            {ticket.ticketQuantity} x
                          </span>
                          <span className="item-name">{ticket.title}</span>
                        </div>
                        <span className="item-price">
                          {ticket.currency}{" "}
                          {itemTotal.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
              {totalGuests > 0 && (
                <div className="details-section">
                  <h4 className="details-title">Guests - {totalGuests}</h4>
                  <div className="details-items">
                    {addedTickets.map((ticket) => {
                      if (
                        ticket.guestCount > 0 &&
                        ticket.guest_details &&
                        ticket.ticket_status === "onsale" &&
                        ticket.guest_details.ticket_status === "onsale"
                      ) {
                        const g_tax_options =
                          typeof ticket.guest_details.tax_options === "string"
                            ? JSON.parse(ticket.guest_details.tax_options)
                            : ticket.guest_details.tax_options || [];
                        const g_relevantTaxes = stateIsSame
                          ? g_tax_options.filter((t) =>
                              ["CGST", "SGST"].includes(t.tax_name)
                            )
                          : g_tax_options.filter((t) => t.tax_name === "IGST");
                        const g_rate =
                          g_relevantTaxes.reduce(
                            (sum, t) =>
                              sum + (Number.parseFloat(t.tax_percentage) || 0),
                            0
                          ) / 100;
                        const g_tax_type =
                          ticket.guest_details.tax_type || "No Tax";
                        let gTotal = ticket.guestPrice * ticket.guestCount;
                        if (g_tax_type === "Excluding Tax") {
                          gTotal +=
                            ticket.guestPrice * ticket.guestCount * g_rate;
                        }
                        gTotal = Math.round(gTotal * 100) / 100;
                        return (
                          <div
                            key={`${ticket.id}-guest`}
                            className="detail-item"
                          >
                            <div className="item-info">
                              <span className="item-quantity">
                                {ticket.guestCount} x
                              </span>
                              <span className="item-name">
                                Accompanying Person ({ticket.title})
                              </span>
                            </div>
                            <span className="item-price">
                              {ticket.currency}{" "}
                              {gTotal.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>
                        );
                      }
                      return null;
                    })}
                  </div>
                </div>
              )}
              {addedTickets.some((ticket) =>
                ticket.addons.some((addon) => addon.isAdded)
              ) && (
                <div className="details-section">
                  <h4 className="details-title">
                    Add-ons -{" "}
                    {addedTickets.reduce(
                      (sum, ticket) =>
                        sum +
                        ticket.addons.reduce(
                          (addonSum, addon) =>
                            addonSum + (addon.isAdded ? addon.quantity : 0),
                          0
                        ),
                      0
                    )}
                  </h4>
                  <div className="details-items">
                    {addedTickets.map((ticket) =>
                      ticket.addons.map((addon) => {
                        if (addon.isAdded) {
                          const a_tax_options = addon.tax_options || [];
                          const a_relevantTaxes = stateIsSame
                            ? a_tax_options.filter((t) =>
                                ["CGST", "SGST"].includes(t.tax_name)
                              )
                            : a_tax_options.filter(
                                (t) => t.tax_name === "IGST"
                              );
                          const a_rate =
                            a_relevantTaxes.reduce(
                              (sum, t) =>
                                sum +
                                (Number.parseFloat(t.tax_percentage) || 0),
                              0
                            ) / 100;
                          const a_tax_type = addon.tax_type || "No Tax";
                          const a_base =
                            addon.addons_type === "variant" &&
                            addon.selectedVariant
                              ? Number.parseFloat(
                                  addon.selectedVariant.price
                                ) || 0
                              : Number.parseFloat(addon.price || 0);
                          let aTotal = a_base * addon.quantity;
                          if (a_tax_type === "Excluding Tax") {
                            aTotal += a_base * addon.quantity * a_rate;
                          }
                          aTotal = Math.round(aTotal * 100) / 100;
                          return (
                            <div
                              key={`${ticket.id}-addon-${addon.id}`}
                              className="detail-item"
                            >
                              <div className="item-info">
                                <span className="item-quantity">
                                  {addon.quantity} x
                                </span>
                                <span className="item-name">
                                  {addon.add_on_name}{" "}
                                  {addon.selectedVariant
                                    ? `(${addon.selectedVariant.name})`
                                    : ""}
                                </span>
                              </div>
                              <span className="item-price">
                                {addon.currency}{" "}
                                {aTotal.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </span>
                            </div>
                          );
                        }
                        return null;
                      })
                    )}
                  </div>
                </div>
              )}
              <div className="pricing-breakdown">
                <div className="breakdown-item">
                  <span>Subtotal</span>
                  <span>
                    {addedTickets?.[0]?.currency || "INR"}{" "}
                    {subtotal.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
                <div className="breakdown-item">
                  <span>
                    {taxName} {addedTickets?.[0]?.currency || "INR"}{" "}
                    {tax.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                  <span></span>
                </div>
                <div className="breakdown-item total-row">
                  <span>Total</span>
                  <span>
                    {addedTickets?.[0]?.currency || "INR"}{" "}
                    {total.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
  if (loading) {
    return (
      <div className="loader-container">
        <SkeletonLoader />
      </div>
    );
  }
  if (showSuccessLoader) {
    return (
      <div className="loader-container">
        <TraditionalLoader />
      </div>
    );
  }
  if (tickets.length === 0 && !loading && !errorMessage) {
    return <NoTicketsAvailable />;
  }
  if (errorMessage && !showSuccessLoader) {
    return (
      <div className="error-container max-w-4xl mx-auto px-4 py-8">
        <div className="error-message text-red-500 text-lg font-semibold text-center">
          {errorMessage}
        </div>
        <div className="mt-4 text-center">
          <button
            onClick={() => setErrorMessage("")}
            className="btn btn-primary"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }
  const eventStatus = eventData?.isPrivate
    ? "live"
    : eventData?.event?.status || "live";
  switch (eventStatus) {
    case "live":
      return <RegistrationPage />;
    case "upcoming":
      return <ComingSoon eventData={eventData?.event} />;
    case "completed":
      return <CompletedEvent eventData={eventData?.event} />;
    default:
      return <ComingSoon eventData={eventData?.event} />;
  }
}